// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__v_MWz","title":"style_title__K6zVa"};